import { createFileRoute, Outlet, useLocation } from '@tanstack/react-router';
import ManagersLayout from '../../../components/portals/ManagersLayout';
import { ManagersPortalProvider } from '../../../contexts/ManagersPortalContext';
import { RequireRole } from '../../../components/site/RequireRole';

/**
 * Stable layout for all `/portal/managers/*` pages.
 * Keeps ManagersPortalProvider mounted across B→C (employees→shifts) navigation
 * so Convex class/student queries are not torn down and re-subscribed on every click.
 */
export const Route = createFileRoute('/portal/managers')({
  component: ManagersRouteLayout,
});

function ManagersRouteLayout() {
  const location = useLocation();
  return (
    <RequireRole role="manager">
      <ManagersPortalProvider>
        <ManagersLayout currentSection={getCurrentSection(location.pathname)}>
          <Outlet />
        </ManagersLayout>
      </ManagersPortalProvider>
    </RequireRole>
  );
}

function getCurrentSection(pathname: string) {
  if (pathname.includes('/classes')) return 'classes';
  if (pathname.includes('/signing')) return 'signing';
  if (pathname.includes('/accounts')) return 'accounts';
  if (pathname.includes('/hr/payroll')) return 'hr-payroll';
  if (pathname.includes('/hr/shifts')) return 'hr-shifts';
  if (pathname.includes('/hr/employees')) return 'hr-employees';
  if (pathname.includes('/hr')) return 'hr-overview';
  if (pathname.includes('/employment')) return 'hr-employees';
  if (pathname.includes('/shifts')) return 'hr-shifts';
  if (pathname.includes('/settings')) return 'settings';
  return 'students';
}
